module.exports = __webpack_public_path__ + "img/2023.6f45b8de.png";